import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";


import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';


import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


import { patchFournisseurEmailSuiviSAVByFoussier } from 'utils/posters';

import { EmailValidationRegex } from 'constants.js';


const FournisseurEmailSuiviSAVByFoussier = ({ fournisseurId, valeur, patchFournisseurEmailSuiviSAVByFoussier}) => {

    const [valeurInitiale, setValeurInitiale] = useState(valeur);
    const [valeurCourante, setValeurCourante] = useState(valeur);
    const [error, setError] = useState('');
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);


    const handleCancel = () => {
        setValeurCourante(valeurInitiale);
        setEditing(false);
        setError('');
    };


    const handleChange = (newValue) => {
        setValeurCourante(newValue);
        if (!newValue || EmailValidationRegex.test(newValue)) {
            setError('');
        }
        else {
            setError("Adresse email non valide");
        }
    };



    const handleSave = async () => {

        console.log("saving fournisseurId value = ", fournisseurId, valeurCourante);

        setEditing(false);

        if (valeurInitiale !== valeurCourante) {

            setSaving(true);

            var result = await patchFournisseurEmailSuiviSAVByFoussier({ id: fournisseurId, emailSuiviSAVByFoussier: valeurCourante });

            if (result) {
                setValeurInitiale(valeurCourante);
            }
            else {
                setValeurCourante(valeurInitiale);
            }
            setSaving(false);
        }
        else {
            console.log("Pas de changement pas d'appel api");
        }
    };


    return (
        <>
            <TextField
                label={"Email pour suivi"}
                autoFocus
                disabled={!editing}
                value={valeurCourante}
                onChange={e => handleChange(e.target.value)}

                error={!!error}
                helperText={error}

                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">

                            {!editing && !saving && (<IconButton onClick={() => setEditing(true)}><EditIcon /></IconButton>)}

                            {editing && (
                                <>
                                    <IconButton onClick={handleCancel} color="error"><CancelIcon /></IconButton>
                                    <IconButton onClick={handleSave} color="success" disabled={!!error}><CheckCircleIcon /></IconButton>
                                </>
                            )}

                            {saving && (<CircularProgress color="secondary" size={16} />)}

                        </InputAdornment>)
                }}
            />
        </>
    );
};



const mapDispatchToProps = {
    patchFournisseurEmailSuiviSAVByFoussier
};

export default connect(null, mapDispatchToProps)(FournisseurEmailSuiviSAVByFoussier);